import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-355126a5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "selected-subscription" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "Plan seleccionado", -1))
const _hoisted_3 = { class: "plan" }
const _hoisted_4 = { class: "plan-group" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "plan-title" }
const _hoisted_7 = { class: "subscription-title" }
const _hoisted_8 = { class: "total" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "total__title" }, "Total"),
  /*#__PURE__*/_createElementVNode("span", { class: "total__vat" }, "IVA incluido")
], -1))
const _hoisted_10 = { class: "total__sum total-price-discount-price" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = {
  key: 0,
  class: "total-price-discount-name"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("img", {
          src: require('@/assets/images/' + _ctx.CardColor[_ctx.plan['$name']]),
          alt: "card"
        }, null, 8, _hoisted_5),
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_6, "Plan " + _toDisplayString(_ctx.plan.name), 1),
          _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.subscription.planType), 1)
        ])
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("div", {
          class: _normalizeClass([_ctx.showDiscount() ? 'plan-price-discount': 'plan-price'])
        }, [
          _createElementVNode("span", null, _toDisplayString(_ctx.subscription.basePrice) + "€", 1),
          _createElementVNode("span", null, _toDisplayString(_ctx.originalPriceMonth), 1)
        ], 2)
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _hoisted_9,
      _createElementVNode("div", null, [
        _createElementVNode("span", _hoisted_10, [
          _createElementVNode("span", null, _toDisplayString(_ctx.totalPlanPrice) + "€", 1),
          (_ctx.showDiscount())
            ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_ctx.priceMonth) + "€/mes", 1))
            : (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(_ctx.originalPriceMonth), 1))
        ])
      ])
    ]),
    (_ctx.showDiscount())
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(_ctx.discountName), 1))
      : _createCommentVNode("", true)
  ]))
}